var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, BLUE_500, Divider, DynamicSvg, getTestId, InfoTag, LILAC_400, RightChevronButtonIcon, Typography, WHITE } from '@airtel/air-design-system';
import { Image, Pressable, View } from 'react-native';
import { getPackDetailsListItemWidgetStyles } from './PackDetailsListItemWidgetStyles';
export var PackDetailsListItemWidgetComponent = props => {
  var _props$id = props.id,
    id = _props$id === void 0 ? '' : _props$id,
    _props$infoTagText = props.infoTagText,
    infoTagText = _props$infoTagText === void 0 ? '' : _props$infoTagText,
    _props$packTitle = props.packTitle,
    packTitle = _props$packTitle === void 0 ? {
      text: ''
    } : _props$packTitle,
    _props$packSubTitle = props.packSubTitle,
    packSubTitle = _props$packSubTitle === void 0 ? '' : _props$packSubTitle,
    _props$linkSubTitle = props.linkSubTitle,
    linkSubTitle = _props$linkSubTitle === void 0 ? {
      text: ''
    } : _props$linkSubTitle,
    _props$hideRightChevr = props.hideRightChevronIcon,
    hideRightChevronIcon = _props$hideRightChevr === void 0 ? false : _props$hideRightChevr,
    _props$iconProps = props.iconProps,
    iconProps = _props$iconProps === void 0 ? {} : _props$iconProps,
    iconName = props.iconName,
    _props$imageUrl = props.imageUrl,
    imageUrl = _props$imageUrl === void 0 ? '' : _props$imageUrl,
    _props$hideDivider = props.hideDivider,
    hideDivider = _props$hideDivider === void 0 ? false : _props$hideDivider,
    _props$isPressable = props.isPressable,
    isPressable = _props$isPressable === void 0 ? true : _props$isPressable,
    index = props.index,
    onUserAction = props.onUserAction,
    onItemPress = props.onItemPress,
    style = props.style,
    testID = props.testID,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 20 : _props$iconSize,
    _props$subTitleNumber = props.subTitleNumberOfLines,
    subTitleNumberOfLines = _props$subTitleNumber === void 0 ? 2 : _props$subTitleNumber,
    _props$chevronIconCol = props.chevronIconColor,
    chevronIconColor = _props$chevronIconCol === void 0 ? BLUE_500 : _props$chevronIconCol,
    restProps = __rest(props, ["id", "infoTagText", "packTitle", "packSubTitle", "linkSubTitle", "hideRightChevronIcon", "iconProps", "iconName", "imageUrl", "hideDivider", "isPressable", "index", "onUserAction", "onItemPress", "style", "testID", "iconSize", "subTitleNumberOfLines", "chevronIconColor"]);
  var packDetailsListItemWidgetStyles = getPackDetailsListItemWidgetStyles(props);
  var Wrapper = isPressable ? Pressable : View;
  return _jsxs(_Fragment, {
    children: [_jsxs(Wrapper, Object.assign({}, isPressable && {
      onPress: () => {
        onItemPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onItemPress), {
          index,
          item: props
        }));
      }
    }, {
      style: [packDetailsListItemWidgetStyles.container, style]
    }, restProps, getTestId(testID), {
      children: [_jsxs(View, Object.assign({
        style: packDetailsListItemWidgetStyles.innerContainer
      }, {
        children: [!!imageUrl && _jsx(Image, Object.assign({
          style: [packDetailsListItemWidgetStyles.icon, packDetailsListItemWidgetStyles.imageBorderRadius],
          source: {
            uri: imageUrl,
            height: 20,
            width: 20
          }
        }, getTestId(testID, 'image'))), !!iconName && _jsx(DynamicSvg, Object.assign({
          iconName: iconName,
          fontSize: iconSize,
          style: packDetailsListItemWidgetStyles.icon
        }, iconProps, getTestId(testID, 'icon'))), _jsxs(View, Object.assign({
          style: packDetailsListItemWidgetStyles.planDetailsContainer
        }, {
          children: [!!packTitle && _jsx(Typography, Object.assign({}, getTestId(testID, 'title'), {
            type: "body-para-sm-bold"
          }, packTitle)), !!packSubTitle && _jsx(Typography, Object.assign({
            text: packSubTitle,
            type: "body-para-xs",
            numberOfLines: subTitleNumberOfLines,
            color: BLACK_700,
            style: !!packTitle && packDetailsListItemWidgetStyles.subTitle
          }, getTestId(testID, 'subtitle'))), !!(linkSubTitle === null || linkSubTitle === void 0 ? void 0 : linkSubTitle.text) && _jsx(Pressable, Object.assign({
            onPress: () => {
              linkSubTitle.onPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, linkSubTitle.onPressMetaData)));
            }
          }, getTestId(testID, 'linkSubTitleWrapper'), {
            children: _jsx(Typography, Object.assign({
              type: "body-para-sm"
            }, linkSubTitle, {
              style: !!packTitle && packDetailsListItemWidgetStyles.linkSubTitle
            }, getTestId(testID, 'linkSubTitle')))
          }))]
        }))]
      })), (!!infoTagText || !hideRightChevronIcon) && _jsxs(View, Object.assign({
        style: packDetailsListItemWidgetStyles.rightContainer
      }, {
        children: [!!infoTagText && _jsx(InfoTag, Object.assign({}, getTestId(testID, 'infoTag'), {
          subType: "offer",
          text: infoTagText
        })), !hideRightChevronIcon && _jsx(RightChevronButtonIcon, Object.assign({
          fontSize: 24,
          color: chevronIconColor,
          style: !hideRightChevronIcon && packDetailsListItemWidgetStyles.rightIcon
        }, getTestId(testID, 'rightChevron')))]
      }))]
    })), !hideDivider && _jsx(Divider, {
      height: 2,
      color: LILAC_400,
      shadowColor: WHITE
    })]
  });
};
PackDetailsListItemWidgetComponent.genericRendererKey = 'AirPackDetailsListItemWidget';